import type { ProductCategory } from "./purchaseUtils";
import { CATEGORY_MAP } from "./purchaseUtils";

export const generateThankYouMessage = (firstName: string): string => {
  return `${firstName.trim()}, thank you for your purchase!`;
};

export const generatePhysicalProductMessage = (): string => {
  return "Your order will be processed within 48 hours (2 business days) and submitted to the shipping courier. You will receive an email with tracking details once it's available.";
};

export const generateTrainingMessage = (category: ProductCategory): string => {
  const categoryInfo = CATEGORY_MAP[category];
  return `Your next step is to complete the ${categoryInfo.longTitle} Training, available through`;
};

export const generateSubscriptionMessage = (category: ProductCategory): string => {
  const categoryInfo = CATEGORY_MAP[category];
  return `Your ${categoryInfo.longTitle} subscription is now active, and we are excited for you to begin delivering the ${categoryInfo.shortTitle} program.`;
};

export const generateAccountCreationMessage = (
  email: string | null,
  isAuthenticated: boolean
): string => {
  if (isAuthenticated || !email) {
    return "";
  }

  return `The next important step is to create your MyUnyte account. An email with directions on how to create your MyUnyte account was sent to ${email}. Please follow the directions in the email.`;
};